import React from "react";
import DefaultPageWrapper from "../templates/DefaultPageWrapper";
import NavBar from "../components/NavBar";
import HeroHome from "../components/HeroHome";
// import FingerprintIllustration1 from "../components/FingerprintIllustration1";
import HomeCTABlock from "../components/HomeCTABlock";
import DataStatsBlock from "../components/DataStatsBlock";
// import Partners from "../components/Partners";
import CustomerLogosBanner from "../components/CustomerLogosBanner";
import Testimonial from "../components/Testimonial";
import Footer from "../components/Footer";
import CtaBanner from "../components/CtaBanner";

function Home() {
  return (
    <DefaultPageWrapper>
      {/*  Site header */}
      <NavBar />

      {/*  Page content */}
      <main className="flex-grow">
        <div
          className="relative h-0 max-w-6xl mx-auto pointer-events-none"
          aria-hidden="true"
        >
          {/* <FingerprintIllustration1 /> */}
        </div>
        {/*  Page sections */}
        <HeroHome />
        <DataStatsBlock />
        <Testimonial
          showTestimonial={[
            "zora",
            "volta",
            "callahan",
            "grenova",
            "mars",
            "cfi",
          ]}
        />
        <CustomerLogosBanner />
        <HomeCTABlock />
        {/* <Partners /> */}
        <CtaBanner
          urlExternal="https://koi.eco"
          urlInternal=""
          title="Ready to get started?"
          subtitle=""
          ctaText="Explore Koi"
          ctaIcon="fa-kit fa-koi-icon-flat"
        />
      </main>

      {/*  Site footer */}
      <Footer />
    </DefaultPageWrapper>
  );
}

export default Home;
